import React from 'react';
import { Layout, Page } from '../layout';

const UnauthorizedPage = () => {
  const pageTitle = 'Unauthorized';

  return (
    <Layout showMenu={false}>
      <Page title={pageTitle}>
        <div>
          This account does not have a VIP Portal license.
          <br />
          To request a license, contact your sponsor or ISACA at{' '}
          <a href='mailto:VIP@isaca.org'>VIP@isaca.org</a>
        </div>
      </Page>
    </Layout>
  );
};

export default UnauthorizedPage;
